angular.module('bmsApp.reports')
	.factory('ReportSvc', [
		'$window',
		'CRUDSvc',
		function ($window, CRUDSvc) {

			function run(param) {
				return CRUDSvc.post('api/report/run', param);
			}

			function openDailyPlanningReport(params) {
				var url = 'merrymaids/planning-report/daily?' + $.param(params);
				$window.open(url, '_blank');
			}

			function openPeriodPlanningReport(params) {
				var url = 'merrymaids/planning-report/period?' + $.param(params);
				$window.open(url, '_blank');
			}

			return {
				run: run,
				openDailyPlanningReport: openDailyPlanningReport,
				openPeriodPlanningReport: openPeriodPlanningReport
			};

		}
	]);
